/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel
 */
export interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel
     */
    value?: string;
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelFromJSON(json: any): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel {
    return JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelToJSON(value?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

